import { StashBoard } from './stashboard/StashBoard';

// Breadcrumb + top-bar Back button are managed inside StashBoard, which reacts to
// the selected-category state. This page is a thin route wrapper.
export default function StashBoardPage() {
  return <StashBoard />;
}
